
import { isString, map } from 'lodash';
import { User } from '../user/user';
import { Revision } from '../revision/revision';

export interface OperationCategory {
  id: string
  text: string
}

export class Operation {
  id: string
  name: string
  category: string
  executions_count: number

  created_at: number
  created_by: User

  updated_at: number
  updated_by: User

  revisions: Revision[]
  revisionsCount: number
  revision: Revision

  constructor(data: any = {}) {
    Object.assign(this, data);

    if(this.created_by) {
      this.created_by = new User(this.created_by);
    }

    if(this.updated_by) {
      this.updated_by = new User(this.updated_by);
    }

    if(this.revision) {
      this.revision = new Revision(this.revision);
    }

    if(this.revisions) {
      this.revisions = map(this.revisions, r => new Revision(r));
    }
  }

  get valid():boolean {
    // name
    if(!isString(this.name)) {
      return false;
    }

    let trimmedName = this.name.trim();

    if(trimmedName.length > 200) {
      return false;
    }

    if(trimmedName.length === 0) {
      return false;
    }

    return true;
  }
}
